/**
 * Developed by Ashvek Technologies · https://ashvek.com · Evidence over prompts
 */

/**
 * Precision GLSL Shaders for Ashvek Obsidian 3D Emblem
 * Custom vertex and fragment shaders for surface refraction and Mars-red rim wireframes.
 */

export const vertexShader = `
  varying vec3 vNormal;
  varying vec3 vViewPosition;
  varying vec2 vUv;

  void main() {
    vUv = uv;
    vNormal = normalize(normalMatrix * normal);
    vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
    vViewPosition = -mvPosition.xyz;
    gl_Position = projectionMatrix * mvPosition;
  }
`;

export const fragmentShader = `
  uniform vec3 uBaseColor;
  uniform vec3 uRimColor;
  uniform float uRimPower;
  uniform float uTime;

  varying vec3 vNormal;
  varying vec3 vViewPosition;
  varying vec2 vUv;

  void main() {
    vec3 normal = normalize(vNormal);
    vec3 viewDir = normalize(vViewPosition);

    // Fresnel rim calculation for Mars-red telemetry highlights
    float fresnel = 1.0 - max(dot(viewDir, normal), 0.0);
    float rimFactor = pow(fresnel, uRimPower);

    // Subtle micro-grid pulse
    float grid = step(0.98, fract(vUv.x * 20.0)) + step(0.98, fract(vUv.y * 20.0));
    vec3 gridEffect = uRimColor * grid * 0.15;

    // Obsidian deep absorption
    vec3 finalColor = mix(uBaseColor, uRimColor, rimFactor * 0.75) + gridEffect;
    gl_FragColor = vec4(finalColor, 1.0);
  }
`;
